export const RHENUS_CHRISTOFLE_WAREHOUSE_ID = "3006";
export const NV_GALLERY_WAREHOUSE_ID = "458";
export const DEMO_WAREHOUSE_ID = "26232";
export const DEMO_WAREHOUSE_FR_ID = "21165";
export const OTHER_DEMO_WAREHOUSE_ID = "21166";
export const CLAREO_WAREHOUSE_ID = "16343";
export const FUSALP_WAREHOUSE_ID = "23302";
